const MarketWalkingEstimate = () => import('@/views/market/competitors/WalkingEstimate')
const WorldMapGdp = () => import('@/views/tourist/gdp/WorldMapGdp')
const Outbound = () => import('@/views/market/outbound/Outbound')
const Population = () => import('@/views/market/population/Population')

const mainWidget = [
  {
    title: 'กราฟเปรียบเทียบปริมาณการโพสผ่านช่องทางต่างๆ ระหว่างประเทศไทยและประเทศคู่แข่ง',
    path: '/admin/widget/:category/:widget_code(56)',
    component: MarketWalkingEstimate
  },
  {
    title: 'แผนที่โลกแสดงข้อมูล GDP',
    path: '/admin/widget/:category/:widget_code(127)',
    component: WorldMapGdp
  },
  {
    title: 'แผนที่โลกแสดงจำนวนนักท่องเที่ยวเดินทางออกนอกประเทศ รายประเทศ',
    path: '/admin/widget/:category/:widget_code(131)',
    component: Outbound
  },
  {
    title: 'แผนที่โลกแสดงจำนวนประชากรรายประเทศ',
    path: '/admin/widget/:category/:widget_code(132)',
    component: Population
  }
]

export default mainWidget.map(data => {
  const { path, title, component, redirect, children } = data

  return {
    path: path,
    name: title,
    component: component,
    redirect: redirect,
    meta: {
      title: title,
      requiresAuth: true,
      breadcrumb: title
    },
    children: children
  }
})